/**
 * Financial
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { StripeAccount } from './stripeAccount';
import { GolfEvent } from './golfEvent';
import { S3File } from './s3File';


export interface Organizer { 
    id?: string;
    createdDate?: string;
    displayName?: string | null;
    contactEmail?: string | null;
    contactPhone?: string | null;
    profilePhotoId?: string | null;
    headerPhotoId?: string | null;
    golfEvents?: Array<GolfEvent> | null;
    headerPhoto?: S3File;
    profilePhoto?: S3File;
    stripeAccount?: StripeAccount;
}

